


import { useEffect, useState } from 'react';
import {
    Button,
    Drawer,
    Box,
    Typography,
    Divider,
    ToggleButton, ToggleButtonGroup
} from '@mui/material';
import { Check, Funnel, X } from 'lucide-react';
import ReactFlagsSelect from 'react-flags-select';
import { allCountries } from 'country-telephone-data';
import PropTypes from 'prop-types';

export default function Filter({ country, setCountry, kycStatus, setKycStatus, cardStatus, setCardStatus }) {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedCountryCode, setSelectedCountryCode] = useState('');
    const [cardKycStatus, setCardKycStatus] = useState('');
    const [loginFilter, setLoginFilter] = useState('');

    useEffect(() => {
        const foundCountry = allCountries.find(
            c =>
                c.name.toLowerCase() === (country || '').toLowerCase() ||
                c.iso2.toUpperCase() === (country || '').toUpperCase()
        );
        setSelectedCountryCode(foundCountry ? foundCountry.iso2.toUpperCase() : '');
        setCardKycStatus(kycStatus || '');
        setLoginFilter(cardStatus || '');
    }, [country, kycStatus, cardStatus]);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const cardKycStatusOptions = [
        { value: 'Approved', label: 'KYC Approved' },
        { value: 'Incomplete', label: 'KYC incomplete' },
        { value: 'NotYetStarted', label: 'KYC Not yet Statrted' },

    ];



    const handleFilter = () => {
        const selectedCountry = allCountries.find(
            c => c.iso2.toUpperCase() === selectedCountryCode
        );
        const countryName = selectedCountry ? selectedCountry.name : '';

        if (typeof setCountry === 'function') setCountry(countryName);
        if (typeof setKycStatus === 'function') setKycStatus(cardKycStatus);
        if (typeof setCardStatus === 'function') setCardStatus(loginFilter);

        setDrawerOpen(false);
    };

    const handleClearAll = () => {
        setSelectedCountryCode('');
        setCardKycStatus('');
        setLoginFilter('');

        if (typeof setCountry === 'function') setCountry('');
        if (typeof setKycStatus === 'function') setKycStatus('');
        if (typeof setCardStatus === 'function') setCardStatus('');

        setDrawerOpen(false);
    };

    const getStatusColor = (value) => {
        if (value === 'Approved') return '#a5d6a7';
        if (value === 'Rejected') return '#ef9a9a';
        return 'inherit';
    };



    return (
        <div style={{ padding: '20px' }}>

            <Button variant="text" startIcon={<Funnel fontSize="inherit" />} onClick={toggleDrawer(true)}>Filter</Button>

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
            >
                <Box sx={{ width: 400, p: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Filters</Typography>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={toggleDrawer(false)}
                            aria-label="Close"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0,
                            }}
                        >
                            <img
                                src={require('../../assets/images/icons/close-circle.svg').default}
                                alt="close-circle"
                                style={{ width: 24, height: 24 }}
                            />
                        </button>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <ReactFlagsSelect
                        selected={selectedCountryCode}
                        onSelect={(code) => setSelectedCountryCode(code)}
                        searchable
                        countries={allCountries.map((c) => c.iso2.toUpperCase())}
                        fullWidth
                        style={{ width: '100%' }}
                    />

                    <div className="mt-4">
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{
                                fontWeight: 600,
                                color: '#333',
                                letterSpacing: '0.5px',
                                mb: 1.5,
                            }}
                        >
                            Card KYC Status
                        </Typography>

                        <ToggleButtonGroup
                            value={cardKycStatus}
                            exclusive
                            onChange={(e, newValue) => {
                                if (newValue !== null) {
                                    setCardKycStatus(newValue);
                                }
                            }}
                            fullWidth
                            sx={{
                                borderRadius: '14px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                                padding: '6px',
                                backgroundColor: '#fafafa',
                                border: '1px solid #e8e8e8',
                                transition: 'all 0.35s cubic-bezier(0.33, 1, 0.68, 1)',

                                '& .MuiToggleButton-root': {
                                    flex: 1,
                                    textTransform: 'none',
                                    fontSize: '13.5px',
                                    fontWeight: 500,
                                    borderRadius: '10px',
                                    padding: '12px 8px',
                                    color: '#444',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                    transition: 'all 0.35s cubic-bezier(0.33, 1, 0.68, 1)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 0.5,
                                    minHeight: 56,

                                    '&:hover': {
                                        backgroundColor: '#f2f2f2',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    },

                                    '&.Mui-selected': {
                                        color: '#fff !important',
                                        backgroundColor: '#000 !important',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
                                        fontWeight: 600,

                                        '&:hover': {
                                            backgroundColor: '#1a1a1a !important',
                                            transform: 'translateY(-3px)',
                                            boxShadow: '0 8px 24px rgba(0,0,0,0.24)',
                                        },
                                    },

                                    '&:not(:last-child)': {
                                        marginRight: '6px',
                                    },

                                    '&:first-of-type': {
                                        color: '#777',
                                        fontWeight: 400,

                                        '&:hover': {
                                            backgroundColor: '#ececec',
                                        },

                                        '&.Mui-selected': {
                                            backgroundColor: '#333 !important',
                                            color: '#fff !important',
                                        },
                                    },
                                },
                            }}
                        >
                            {cardKycStatusOptions.map((option) => (
                                <ToggleButton key={option.value} value={option.value} aria-label={option.label}>
                                    {option.icon && (
                                        <Box
                                            sx={{
                                                opacity: 0.85,
                                                color: getStatusColor(option.value),
                                                transition: 'color 0.3s',
                                            }}
                                        >
                                            {option.icon}
                                        </Box>
                                    )}
                                    <Typography
                                        sx={{
                                            fontSize: '13px',
                                            fontWeight: option.value === '' ? 400 : 500,
                                        }}
                                    >
                                        {option.label}
                                    </Typography>
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>

                    <div className="mt-4">
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{
                                fontWeight: 600,
                                color: '#333',
                                letterSpacing: '0.5px',
                                mb: 1.5,
                            }}
                        >
                            Card Status
                        </Typography>

                        <ToggleButtonGroup
                            value={loginFilter}
                            exclusive
                            onChange={(e, newValue) => {
                                if (newValue !== null) {
                                    setLoginFilter(newValue);
                                }
                            }}
                            fullWidth
                            sx={{
                                borderRadius: '12px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                padding: '4px',
                                backgroundColor: '#fafafa',
                                border: '1px solid #e0e0e0',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                                '& .MuiToggleButton-root': {
                                    flex: 1,
                                    textTransform: 'none',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    color: '#333',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,

                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 3px 8px rgba(0,0,0,0.12)',
                                    },

                                    '&.Mui-selected': {
                                        color: '#fff !important',
                                        backgroundColor: '#000 !important',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 16px rgba(0,0,0,0.18)',
                                        fontWeight: 600,

                                        '&:hover': {
                                            backgroundColor: '#1a1a1a !important',
                                            transform: 'translateY(-3px)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.22)',
                                        },
                                    },

                                    '&:not(:last-child)': {
                                        marginRight: '4px',
                                    },
                                },
                            }}
                        >
                            <ToggleButton value="Active" aria-label="Active">
                                Active
                            </ToggleButton>
                            <ToggleButton value="InActive" aria-label="InActive">
                                InActive
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>

                    <Divider sx={{ my: 3 }} />



                    <Box sx={{ display: 'flex', gap: 2, mt: 4, mb: 1 }}>
                        <Button
                            onClick={handleClearAll}
                            fullWidth
                            sx={{
                                py: 1.5,
                                px: 3,
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '15px',
                                color: '#d32f2f',
                                backgroundColor: '#fff',
                                border: '2px solid #ffebee',
                                boxShadow: '0 2px 8px rgba(211,47,47,0.08)',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                                '&:hover': {
                                    backgroundColor: '#fff9f9',
                                    borderColor: '#ffcdd2',
                                    boxShadow: '0 4px 16px rgba(211,47,47,0.15)',
                                    transform: 'translateY(-1px)',
                                },

                                '&:active': {
                                    transform: 'translateY(0)',
                                    boxShadow: '0 2px 6px rgba(211,47,47,0.12)',
                                },

                                '& .MuiButton-startIcon': {
                                    mr: 1,
                                    transition: 'transform 0.2s',
                                },

                                '&:hover .MuiButton-startIcon': {
                                    transform: 'scale(1.1)',
                                },
                            }}
                            startIcon={<X size={18} />}
                        >
                            Clear All
                        </Button>

                        <Button
                            onClick={handleFilter}
                            fullWidth
                            variant="contained"
                            sx={{
                                py: 1.5,
                                px: 3,
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '15px',
                                backgroundColor: '#000',
                                color: '#fff',
                                boxShadow: '0 3px 10px rgba(0,0,0,0.12)',
                                transition: 'all 0.35s cubic-bezier(0.33, 1, 0.68, 1)',

                                '&:hover': {
                                    backgroundColor: '#1a1a1a',
                                    boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
                                    transform: 'translateY(-2px)',
                                },

                                '&:active': {
                                    transform: 'translateY(0)',
                                    boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
                                },

                                '& .MuiButton-startIcon': {
                                    mr: 1,
                                    transition: 'transform 0.2s',
                                },

                                '&:hover .MuiButton-startIcon': {
                                    transform: 'scale(1.15) rotate(5deg)',
                                },
                            }}
                            startIcon={<Check size={18} />}
                        >
                            Apply Filters
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </div>
    );
}

Filter.propTypes = {
    country: PropTypes.any.isRequired,
    setCountry: PropTypes.any.isRequired,
    kycStatus: PropTypes.any.isRequired,
    setKycStatus: PropTypes.any.isRequired,
    cardStatus: PropTypes.any.isRequired,
    setCardStatus: PropTypes.any.isRequired,
};